module.exports = __webpack_public_path__ + "img/cover.a8d2bdda.jpg";